package core.upload

import core.io.CustomHttpClient
import core.io.CustomHttpResponse
import core.io.CustomHttpResponse.*
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.await
import kotlinx.coroutines.withContext
import org.w3c.files.File
import org.w3c.files.FileReader
import kotlin.js.Promise

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 04.11.22
 * Author : mariorosshirt
 */
object UploadHelper {

    private val mAcceptedFileTypes = listOf("image/png", "image/jpeg", "image/jpg")

    suspend fun getBase64(file: File): String? {
        return withContext(Dispatchers.Default) {
            Promise<String?> { resolve, _ ->
                val reader = FileReader()
                reader.readAsDataURL(file)
                reader.onloadend = {
                    resolve.invoke(reader.result.toString())
                }
            }.await()
        }
    }

    suspend fun handleFileInputChange(targetFile: File?, application: Int): CustomHttpResponse<String> {
        var token: CustomHttpResponse<String> = Error.Unknown()
        withContext(Dispatchers.Default) {
            targetFile?.let {
                if (mAcceptedFileTypes.contains(it.type)) {
                    val base64String = getBase64(it)
                    val mClient = CustomHttpClient()
                    base64String?.let { base64String ->
                        token = mClient.uploadImage(base64String, application).let { response ->
                            when (response) {
                                is Success -> Success(response.data.mToken)
                                is Error.NoInternet<*> -> Error.NoInternet()
                                is Error.Timeout<*> -> Error.Timeout()
                                is Error.Unknown<*> -> Error.Unknown()
                            }
                        }
                    }
                }
            }
        }
        return token
    }

    fun getAcceptedFileTypes(): String {
        return mAcceptedFileTypes.joinToString(separator = ", ") { it }
    }
}